export default __webpack_public_path__ + "static/media/dashboard.33bb99b8.svg";